import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';

const state = {
    resultadosVentasClientes: [],
    cantidadClientesResultadoVentasClientes: 5,
    resultadosVentasClientesLabels: [],
    resultadosVentasClientesColors: [],
    resultadosVentasClientesData: [],

    resultadosPresupuestosClientes: [],
    resultadosPresupuestosClientesLabels: [],
    resultadosPresupuestosClientesColors: [],
    resultadosPresupuestosClientesData: [],

    resultadosPresupuestosTipos: [],
    resultadosPresupuestosTiposLabels: [],
    resultadosPresupuestosTiposColors: [],
    resultadosPresupuestosTiposData: [],

    resultadosPresupuestosTiposImporte: [],
    resultadosPresupuestosTiposImporteLabels: [],
    resultadosPresupuestosTiposImporteColors: [],
    resultadosPresupuestosTiposImporteData: [],

    resultadosRubrosTrabajos: [],
    resultadosRubrosTrabajosLabels: [],
    resultadosRubrosTrabajosColors: [],
    resultadosRubrosTrabajosData: [],

    resultadosRentabilidadBrutaClientes: [],
    resultadosRentabilidadBrutaClientesPresupuestos: [],

    resultados: [],

    // evolucionClientes: [],
    evolucionGrandesClientes: [],
    evolucionPyMEClientes: [],
    evolucionClientesPeriodos: [],
    evolucionGrandesClientesStepSize: 0,
    evolucionGrandesClientesMax: 0,
    evolucionPyMEClientesStepSize: 0,
    evolucionPyMEClientesMax: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR_INDICADORES' (state) {
        state.resultadosVentasClientes = [];
        state.resultadosVentasClientesLabels = [];
        state.resultadosVentasClientesColors = [ 
            '#E46651', 
            '#41B883', 
            '#FAFA05', 
            '#0000FF', 
            '#FFA500',
            '#17A204',
            '#04A29D',
            '#08CADD',
            '#DD08C6',
            '#AA1FC8',
            '#9B9B9B'
        ];
        state.resultadosVentasClientesData = [];

        state.resultadosPresupuestosClientes = [];
        state.resultadosPresupuestosClientesLabels = [];
        state.resultadosPresupuestosClientesColors = [ 
            '#E46651', 
            '#41B883', 
            '#FAFA05', 
            '#0000FF', 
            '#FFA500',
            '#17A204',
            '#04A29D',
            '#08CADD',
            '#DD08C6',
            '#AA1FC8',
            '#9B9B9B'
        ];
        state.resultadosPresupuestosClientesData = [];

        state.resultadosPresupuestosTipos = [];
        state.resultadosPresupuestosTiposLabels = [];
        state.resultadosPresupuestosTiposColors = [ 
            '#E46651', 
            '#41B883', 
            '#FAFA05', 
            '#0000FF', 
            '#FFA500',
            '#17A204',
            '#04A29D',
            '#08CADD',
            '#DD08C6',
            '#AA1FC8',
            '#9B9B9B'
        ];
        state.resultadosPresupuestosTiposData = [];

        state.resultadosPresupuestosTiposImporte = [];
        state.resultadosPresupuestosTiposImporteLabels = [];
        state.resultadosPresupuestosTiposImporteColors = [ 
            '#E46651', 
            '#41B883', 
            '#FAFA05', 
            '#0000FF', 
            '#FFA500',
            '#17A204',
            '#04A29D',
            '#08CADD',
            '#DD08C6',
            '#AA1FC8',
            '#9B9B9B'
        ];
        state.resultadosPresupuestosTiposImporteData = [];

        state.resultadosRubrosTrabajos = [];
        state.resultadosRubrosTrabajosLabels = [];
        state.resultadosRubrosTrabajosColors = [ 
            '#E46651', 
            '#41B883', 
            '#FAFA05', 
            '#0000FF', 
            '#FFA500',
            '#17A204',
            '#04A29D',
            '#08CADD',
            '#DD08C6',
            '#AA1FC8',
            '#9B9B9B'
        ];
        state.resultadosRubrosTrabajosData = [];

        state.resultadosRentabilidadBrutaClientes = [];

        // state.evolucionClientes = [];
        state.evolucionGrandesClientes = [];
        state.evolucionPyMEClientes = [];
        state.evolucionClientesPeriodos = [];
    },
    'SET_RESULTADOS_VENTAS_CLIENTES'(state, resultados) {
        if (resultados) {
            state.resultadosVentasClientes = resultados.map(cliente => ({
                ...cliente,
                pjeParticipacion: parseFloat(cliente.pjeParticipacion) * parseFloat(100)
            }));
        }

        for (let index = 0; index < state.resultadosVentasClientes.length; index++) {
            if (index < state.resultadosVentasClientesColors.length) {
                state.resultadosVentasClientes[index].color = state.resultadosVentasClientesColors[index];
            }
        }

        state.resultadosVentasClientesLabels = state.resultadosVentasClientes
            .map(resultadoCliente => resultadoCliente.cliente.trim());
        
        state.resultadosVentasClientesData = state.resultadosVentasClientes
            .map(resultadoCliente => roundToTwo(parseFloat(resultadoCliente.pjeParticipacion)));
    },
    /* Ranking de Presupuestos (por cantidad) */
    'SET_RESULTADOS_PRESUPUESTOS_CLIENTES'(state, resultados) {
        if (resultados) {
            state.resultadosPresupuestosClientes = resultados.map(cliente => ({
                ...cliente,
                pjeParticipacion: parseFloat(cliente.pjeParticipacion) * parseFloat(100)
            }));
        }

        for (let index = 0; index < state.resultadosPresupuestosClientes.length; index++) {
            if (index < state.resultadosPresupuestosClientesColors.length) {
                state.resultadosPresupuestosClientes[index].color = state.resultadosPresupuestosClientesColors[index];
            }
        }

        state.resultadosPresupuestosClientesLabels = state.resultadosPresupuestosClientes
            .map(resultadoCliente => resultadoCliente.cliente.trim());
        
        state.resultadosPresupuestosClientesData = state.resultadosPresupuestosClientes
            .map(resultadoCliente => roundToTwo(parseFloat(resultadoCliente.pjeParticipacion)));
    },
    /* Ranking de Presupuestos (por tipo) */
    'SET_RESULTADOS_PRESUPUESTOS_TIPOS'(state, resultados) {
        if (resultados) {
            state.resultadosPresupuestosTipos = resultados.map(tipoPresupuesto => ({
                ...tipoPresupuesto,
                pjeParticipacion: parseFloat(tipoPresupuesto.pjeParticipacion) * parseFloat(100)
            }));
        }

        for (let index = 0; index < state.resultadosPresupuestosTipos.length; index++) {
            if (index < state.resultadosPresupuestosTiposColors.length) {
                state.resultadosPresupuestosTipos[index].color = state.resultadosPresupuestosTiposColors[index];
            }
        }

        state.resultadosPresupuestosTiposLabels = state.resultadosPresupuestosTipos
            .map(resultadoTipo => resultadoTipo.tipoPresupuesto.trim());
        
        state.resultadosPresupuestosTiposData = state.resultadosPresupuestosTipos
            .map(resultadoTipo => roundToTwo(parseFloat(resultadoTipo.pjeParticipacion)));
    },
    /* Ranking de Presupuestos (por tipo) */
    'SET_RESULTADOS_PRESUPUESTOS_TIPOS_IMPORTE'(state, resultados) {
        if (resultados) {
            state.resultadosPresupuestosTiposImporte = resultados.map(tipoPresupuesto => ({
                ...tipoPresupuesto,
                pjeParticipacion: parseFloat(tipoPresupuesto.pjeParticipacion) * parseFloat(100)
            }));
        }

        for (let index = 0; index < state.resultadosPresupuestosTiposImporte.length; index++) {
            if (index < state.resultadosPresupuestosTiposImporteColors.length) {
                state.resultadosPresupuestosTiposImporte[index].color = state.resultadosPresupuestosTiposImporteColors[index];
            }
        }

        state.resultadosPresupuestosTiposImporteLabels = state.resultadosPresupuestosTiposImporte
            .map(resultadoTipo => resultadoTipo.tipoPresupuesto.trim());
        
        state.resultadosPresupuestosTiposImporteData = state.resultadosPresupuestosTiposImporte
            .map(resultadoTipo => roundToTwo(parseFloat(resultadoTipo.pjeParticipacion)));
    },
    /* Ranking de Rubros de Trabajo */
    'SET_RESULTADOS_RUBROS_TRABAJOS' (state, resultados) {
        if (resultados) {
            state.resultadosRubrosTrabajos = resultados.map(rubroTrabajo => ({
                ...rubroTrabajo,
                pjeParticipacion: parseFloat(rubroTrabajo.pjeParticipacion) * parseFloat(100)
            }));
        }

        for (let index = 0; index < state.resultadosRubrosTrabajos.length; index++) {
            if (index < state.resultadosRubrosTrabajosColors.length) {
                state.resultadosRubrosTrabajos[index].color = state.resultadosRubrosTrabajosColors[index];
            }
        }

        state.resultadosRubrosTrabajosLabels = state.resultadosRubrosTrabajos
            .map(resultadoRubro => resultadoRubro.rubroTrabajo.trim());
        
        state.resultadosRubrosTrabajosData = state.resultadosRubrosTrabajos
            .map(resultadoRubro => roundToTwo(parseFloat(resultadoRubro.pjeParticipacion)));
    },
    /* Rentabilidad Bruta */
    'SET_RESULTADOS_RENTABILIDAD_BRUTA_CLIENTES' (state, resultados) {
        state.resultadosRentabilidadBrutaClientes = resultados.sort(function(a, b){
            let x = a.pjeRentabilidadPromedio;
            let y = b.pjeRentabilidadPromedio;
            if (x < y) { 
                return 1; 
            }
            if (x > y) {
                return -1;
            }
            return 0;
        });
    },

    'INICIALIZAR_RESULTADOS_RENTABILIDAD_BRUTA_CLIENTES_PRESUPUESTOS' (state) {
        state.resultadosRentabilidadBrutaClientesPresupuestos = [];
    },
    'SET_RESULTADOS_RENTABILIDAD_BRUTA_CLIENTES_PRESUPUESTOS' (state, resultados) {
        state.resultadosRentabilidadBrutaClientesPresupuestos = resultados;
    },
    
    'SET_EVOLUCION_CLIENTES' (state, evolucionClientes) {
        let colors = ['#E46651', '#41B883', '#FAFA05', '#0000FF', '#FFA500'];

        if (evolucionClientes) {
            /* Separamos en grandes clientes y PyMes */
            /* Grandes (hardcodeado) => Genomma (23), PG (1) y Mondelez (70)  */

            evolucionClientes.forEach(evolucionCliente => {
                evolucionCliente.montoTotal = evolucionCliente.periodos.reduce((total, periodo) => total + parseFloat(periodo.importe), 0);
                evolucionCliente.montoMaximo = Math.max(...evolucionCliente.periodos.map(periodo => periodo.importe));
            });

            evolucionClientes.sort(function(a, b){
                let x = a.montoTotal;
                let y = b.montoTotal;
                if (x < y) { 
                    return 1; 
                }
                if (x > y) {
                    return -1;
                }
                return 0;
            });

            let index = 0;

            /* Grandes Clientes */
            evolucionClientes.filter(evolucionCliente => evolucionCliente.id == 1
                    || evolucionCliente.id == 23)
                    // || evolucionCliente.id == 70)
                .forEach(evolucionCliente => {
                    if (index <= 4) {
                        state.evolucionGrandesClientes.push({
                            label: evolucionCliente.nombre,
                            backgroundColor: 'transparent',
                            borderColor: colors[index], // '#41B883',
                            pointHoverBackgroundColor: '#fff',
                            borderWidth: 2,
                            data: evolucionCliente.periodos.map(periodo => periodo.importe)
                        })
                    }
                    index++;
                });
            
            let importeMaximo = Math.max(...evolucionClientes
                .filter(evolucionCliente => evolucionCliente.id == 1 || evolucionCliente.id == 23)
                .map(cliente => cliente.montoMaximo));
            let topeMaximo = Math.ceil(importeMaximo / 1000000) * 1000000;
            let stepSize = Math.ceil((topeMaximo / 10) / 1000000) * 1000000;

            state.evolucionGrandesClientesStepSize = Math.ceil(stepSize / 10000000) * 10000000;
            state.evolucionGrandesClientesMax = state.evolucionGrandesClientesStepSize * 10;

            evolucionClientes.filter(evolucionCliente => evolucionCliente.id != 1
                    & evolucionCliente.id != 23)
                    // & evolucionCliente.id != 70)
                .forEach(evolucionCliente => {
                    if (index <= 4) {
                        state.evolucionPyMEClientes.push({
                            label: evolucionCliente.nombre,
                            backgroundColor: 'transparent',
                            borderColor: colors[index], // '#41B883',
                            pointHoverBackgroundColor: '#fff',
                            borderWidth: 2,
                            data: evolucionCliente.periodos.map(periodo => periodo.importe)
                        })
                    }
                    index++;
                });

            importeMaximo = Math.max(...evolucionClientes
                .filter(evolucionCliente => evolucionCliente.id != 1 & evolucionCliente.id != 23)
                .map(cliente => cliente.montoMaximo));
            topeMaximo = Math.ceil(importeMaximo / 1000000) * 1000000;
            stepSize = Math.ceil((topeMaximo / 10) / 1000000) * 1000000;

            state.evolucionPyMEClientesStepSize = Math.ceil(stepSize / 10000000) * 10000000;
            state.evolucionPyMEClientesMax = state.evolucionPyMEClientesStepSize * 10;

            /* Periodos */
            if (evolucionClientes.length != 0) {
                let evolucionCliente = evolucionClientes[0];
                if (evolucionCliente) {
                    if (evolucionCliente.periodos) {
                        evolucionCliente.periodos.forEach(periodoEvolucion => {
                            let mes = '00';
                            if (periodoEvolucion.mes < 10) {
                              mes = '0' + periodoEvolucion.mes.toString().trim();
                            } else {
                              mes = periodoEvolucion.mes.toString().trim();
                            }
                            let periodo = periodoEvolucion.anio.toString().trim() 
                                + '-' + mes
                                + '-01';
                
                            state.evolucionClientesPeriodos.push(moment.utc(periodo).format('MMM/YY'));                            
                        });
                    }
                }
            }
        }
    },

    'INICIALIZAR_RESULTADOS' (state) {
        state.resultados = [];
    },
    'SET_RESULTADOS' (state, resultados) {
        state.resultados = resultados;
    },
   
};

function roundToTwo(num) {    
    return +(Math.round(num + 'e+2')  + 'e-2');
}

function roundNumber(num, scale) {
    if(!("" + num).includes("e")) {
        return +(Math.round(num + "e+" + scale)  + "e-" + scale);
    } else {
        var arr = ("" + num).split("e");
        var sig = ""
        if(+arr[1] + scale > 0) {
        sig = "+";
        }
        return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
    }
} 

const getters = {
    getField,

    resultadosVentasClientes(state) {
        return state.resultadosVentasClientes;
    },
    resultadosVentasClientesLabels(state) {
        return state.resultadosVentasClientesLabels;
    },
    resultadosVentasClientesColors(state) {
        return state.resultadosVentasClientesColors;
    },
    resultadosVentasClientesData(state) {
        return state.resultadosVentasClientesData;
    },

    resultadosPresupuestosClientes(state) {
        return state.resultadosPresupuestosClientes;
    },
    resultadosPresupuestosClientesLabels(state) {
        return state.resultadosPresupuestosClientesLabels;
    },
    resultadosPresupuestosClientesColors(state) {
        return state.resultadosPresupuestosClientesColors;
    },
    resultadosPresupuestosClientesData(state) {
        return state.resultadosPresupuestosClientesData;
    },

    resultadosPresupuestosTipos(state) {
        return state.resultadosPresupuestosTipos;
    },
    resultadosPresupuestosTiposLabels(state) {
        return state.resultadosPresupuestosTiposLabels;
    },
    resultadosPresupuestosTiposColors(state) {
        return state.resultadosPresupuestosTiposColors;
    },
    resultadosPresupuestosTiposData(state) {
        return state.resultadosPresupuestosTiposData;
    },

    resultadosPresupuestosTiposImporte(state) {
        return state.resultadosPresupuestosTiposImporte;
    },
    resultadosPresupuestosTiposImporteLabels(state) {
        return state.resultadosPresupuestosTiposImporteLabels;
    },
    resultadosPresupuestosTiposImporteColors(state) {
        return state.resultadosPresupuestosTiposImporteColors;
    },
    resultadosPresupuestosTiposImporteData(state) {
        return state.resultadosPresupuestosTiposImporteData;
    },

    resultadosRubrosTrabajos(state) {
        return state.resultadosRubrosTrabajos;
    },
    resultadosRubrosTrabajosLabels(state) {
        return state.resultadosRubrosTrabajosLabels;
    },
    resultadosRubrosTrabajosColors(state) {
        return state.resultadosRubrosTrabajosColors;
    },
    resultadosRubrosTrabajosData(state) {
        return state.resultadosRubrosTrabajosData;
    },

    resultadosRentabilidadBrutaClientes(state) {
        return state.resultadosRentabilidadBrutaClientes;
    },
    resultadosRentabilidadBrutaClientesPresupuestos(state) {
        return state.resultadosRentabilidadBrutaClientesPresupuestos;
    },

    resultados(state) {
        return state.resultados;
    },

    // evolucionClientes(state) {
    //     return state.evolucionClientes;
    // },
    evolucionPyMEClientes(state) {
        return state.evolucionPyMEClientes;
    },
    evolucionGrandesClientes(state) {
        return state.evolucionGrandesClientes;
    },
    evolucionClientesPeriodos(state) {
        return state.evolucionClientesPeriodos;
    },
    evolucionGrandesClientesStepSize(state) {
        return state.evolucionGrandesClientesStepSize;
    },
    evolucionGrandesClientesMax(state) {
        return state.evolucionGrandesClientesMax;
    },
    evolucionPyMEClientesStepSize(state) {
        return state.evolucionPyMEClientesStepSize;
    },
    evolucionPyMEClientesMax(state) {
        return state.evolucionPyMEClientesMax;
    }
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES');
            resolve();
        })
    },
    getResultadosVentasClientes ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/cuentas/clientes')
                .then(res => {
                    commit('SET_RESULTADOS_VENTAS_CLIENTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResultadosPresupuestosClientes ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/cuentas/presupuestos')
                .then(res => {
                    commit('SET_RESULTADOS_PRESUPUESTOS_CLIENTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResultadosPresupuestosTipos ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/cuentas/presupuestos-tipos')
                .then(res => {
                    commit('SET_RESULTADOS_PRESUPUESTOS_TIPOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResultadosPresupuestosTiposImporte ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/cuentas/presupuestos-tipos/importes')
                .then(res => {
                    commit('SET_RESULTADOS_PRESUPUESTOS_TIPOS_IMPORTE', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResultadosRubrosTrabajos ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/cuentas/rubros')
                .then(res => {
                    commit('SET_RESULTADOS_RUBROS_TRABAJOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    actualizarCostosOrdenes ( {} ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('indicadores/cuentas/clientes/rentabilidad-bruta/actualizar-costos')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResultadosRentabilidadBrutaClientes ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/cuentas/clientes/rentabilidad-bruta')
                .then(res => {
                    commit('SET_RESULTADOS_RENTABILIDAD_BRUTA_CLIENTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResultadosRentabilidadBrutaClientesPresupuestos ( { commit }, clienteId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS');

            apiAxios.get('indicadores/cuentas/clientes/rentabilidad-bruta/' + clienteId + '/presupuestos')
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getResultadosRentabilidadBrutaClientesOrdenes ( { commit }, clienteId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS');

            apiAxios.get('indicadores/cuentas/clientes/rentabilidad-bruta/' + clienteId + '/ordenes')
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getEvolucionClientes ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/cuentas/clientes/evolucion')
                .then(res => {
                    commit('SET_EVOLUCION_CLIENTES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}